import { BookOpenText } from "lucide-react";
import { TextMediumBaseSetting } from "../Text/MediumText";

import {
  Building2,
  MapPin,
  Landmark,
  Contact2,
  Home,
} from "lucide-react"; // or your icons

export function HeadingWithIcon({
  icon: Icon = BookOpenText,
  title = "Heading",
  iconSize = "h-5 w-5",
  textColor = "text-gray-800",
  iconColor = "text-gray-500",
  otherStyles = ""
}) {
  return (
    <div className={`w-full flex items-center gap-2 mb-2 ${otherStyles}`}>
      <Icon className={`${iconSize} ${iconColor}`} />
      <TextMediumBaseSetting content={title} color={textColor} />
    </div>
  );
}







const iconMapping = {
  "Company Info :": Building2,
  "Business :": Landmark,
  "Address :": MapPin,
  "Billing Address :": Contact2,
  "Delivery Address :": Home,
};

export const SettingHeading = ({
  icon, // optional override icon
  title = "Heading",
  iconSize = "h-4 w-4",
  textColor = "text-[#111537]",
  iconColor='text-gray-500',
  underlineColor = "decoration-baseColor-primary",
  otherStyles = "",
}) => {
  const Icon = icon || iconMapping[title];

  return (
    <div className={`w-full flex items-center gap-2 px-2 ${otherStyles}`}>
      {Icon && <Icon className={`${iconSize} ${iconColor}`} />}
      <p
        className={`py-2 text-sm 2xl:text-sm font-medium ${textColor} underline ${underlineColor} decoration-2 underline-offset-4`}
      >
        {title}
      </p>
    </div>
  );
};



